define(["require", "exports", "tslib", "mobx", "../EntityBase", "../EntityValidationState", "../../utils/EntityUtil", "../../utils/StringUtil", "../domain"], function (require, exports, tslib_1, mobx_1, EntityBase_1, EntityValidationState_1, EntityUtil_1, StringUtil_1, domain_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.WaLandowner = void 0;
    class WaLandowner extends EntityBase_1.Entity {
        constructor(entity = null, parent = null) {
            super();
            Object.defineProperty(this, "WaId", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "WaIdError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Type", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "TypeError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "BusinessName", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "BusinessNameError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "BusinessNameSearchIndex", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "BusinessNameSearchIndexError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "ContactFirstName", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "ContactFirstNameError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "ContactLastName", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "ContactLastNameError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "ContactFullName", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "ContactFullNameError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "ContactNameSearchIndex", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "ContactNameSearchIndexError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "ContactPosition", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "ContactPositionError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Signatory_1", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Signatory_1Error", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Signatory_2", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Signatory_2Error", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Signatory_3", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Signatory_3Error", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "PostalAddress_1", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "PostalAddress_1Error", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "PostalAddress_2", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "PostalAddress_2Error", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Town", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "TownError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "State", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "StateError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Postcode", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "PostcodeError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Phone", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "PhoneError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Fax", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FaxError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Email", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "EmailError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Abn", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AbnError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "EnableNotifications", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "EnableNotificationsError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Wa", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "IsBusinessNameRequired", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: false
            });
            Object.defineProperty(this, "IsContactPositionRequired", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: false
            });
            Object.defineProperty(this, "IsSignatory1Required", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: false
            });
            Object.defineProperty(this, "IsSignatory2Required", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: false
            });
            Object.defineProperty(this, "IsSignatory3Required", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: false
            });
            (0, mobx_1.makeObservable)(this);
            this.init(entity, parent, WaLandowner.ObservableFields);
        }
        onCreate(parent) {
            this.Id = (0, EntityUtil_1.id)();
            this.Wa = parent;
            this.WaId = parent.Id;
            this.PersistanceState = EntityBase_1.PersistanceStates.NEW_RECORD;
            this.SecurityAccessLevel = EntityBase_1.EntitySecurityAccessLevels.READ_WRITE;
        }
        onRead(entity, parent) {
            this.Wa = parent;
            this.merge(entity);
        }
        merge(entity) {
            let a = this;
            let b = entity;
            if (!a || !b)
                throw new Error(`${this.constructor.name}.merge() expected a and b to be defined`);
            a.ObjectId = b.ObjectId;
            a.Id = (0, EntityUtil_1.toInt)(entity.Id);
            a.WaId = (0, EntityUtil_1.toInt)(entity.WaId);
            a.Type = (0, EntityUtil_1.toInt)(entity.Type);
            a.BusinessName = b.BusinessName;
            a.BusinessNameSearchIndex = b.BusinessNameSearchIndex;
            a.ContactFirstName = b.ContactFirstName;
            a.ContactLastName = b.ContactLastName;
            a.ContactFullName = b.ContactFullName;
            a.ContactNameSearchIndex = b.ContactNameSearchIndex;
            a.ContactPosition = b.ContactPosition;
            a.Signatory_1 = b.Signatory_1;
            a.Signatory_2 = b.Signatory_2;
            a.Signatory_3 = b.Signatory_3;
            a.PostalAddress_1 = b.PostalAddress_1;
            a.PostalAddress_2 = b.PostalAddress_2;
            a.Town = b.Town;
            a.State = b.State;
            a.Postcode = b.Postcode;
            a.Phone = b.Phone;
            a.Fax = b.Fax;
            a.Email = b.Email;
            a.Abn = b.Abn;
            a.EnableNotifications = (0, EntityUtil_1.toInt)(entity.EnableNotifications);
            a.PersistanceState = b.PersistanceState;
            a.SecurityAccessLevel = b.SecurityAccessLevel;
            this.postMerge();
        }
        postMerge() {
        }
        onReady() {
            this.addChangeEventAction("ContactFirstName", this.onNameChange.bind(this));
            this.addChangeEventAction("ContactLastName", this.onNameChange.bind(this));
            this.addChangeEventAction("PostalAddress_1", this.onAddressChange.bind(this));
            this.addChangeEventAction("PostalAddress_2", this.onAddressChange.bind(this));
            this.addChangeEventAction("Town", this.onAddressChange.bind(this));
            this.addChangeEventAction("State", this.onAddressChange.bind(this));
            this.addChangeEventAction("Postcode", this.onAddressChange.bind(this));
            this.addChangeEventAction("Type", this.updateApplicableFields.bind(this));
            this.updateApplicableFields();
        }
        hasChanges(recurseChildren = true) {
            let hasChanges = false;
            this.walk((entity) => {
                if (!hasChanges && recurseChildren && entity != null) {
                    hasChanges = hasChanges || entity.hasChanges();
                }
            }, { skipRoot: true });
            hasChanges = hasChanges || (this.PersistanceState != EntityBase_1.PersistanceStates.EXISTING_UNMODIFIED);
            return hasChanges;
        }
        validate(recurseChildren = true) {
            let validationState = new EntityValidationState_1.EntityValidationState(this.Id, WaLandowner.AliasName);
            this.reset();
            this._validate(validationState, recurseChildren);
            if (this.PersistanceState != EntityBase_1.PersistanceStates.MARKED_FOR_DELETION) {
                if (this.EnableNotifications == 1) {
                    this.EmailError = (this.Email == null || !StringUtil_1.StringUtil.isEmail(this.Email)) ? "Email is required" : null;
                    if (this.EmailError != null) {
                        validationState.addError(this.EmailError);
                    }
                }
                this.PhoneError = this.Phone == null || !StringUtil_1.StringUtil.IsPhoneNumber(this.Phone) ? "A valid Phone Number is required" : null;
                if (this.PhoneError != null) {
                    validationState.addError(this.PhoneError);
                }
            }
            return validationState;
        }
        _validate(validationState, recurseChildren = true) {
            if (this.PersistanceState != EntityBase_1.PersistanceStates.MARKED_FOR_DELETION) {
                this.validateReqNumber(validationState, "Id", "ID");
                this.validateReqNumber(validationState, "WaId", "Water Agreement ID");
                this.validateReqString(validationState, "ContactFirstName", "Landowner Given Name(s)");
                this.validateReqString(validationState, "ContactLastName", "Landowner Surname");
                this.validateReqString(validationState, "PostalAddress_1", "Landowner Address line 1");
                this.validateReqString(validationState, "Town", "Landowner Town");
                this.validateReqString(validationState, "State", "Landowner State");
                this.validateReqString(validationState, "Postcode", "Landowner Postcode");
                this.validateReqString(validationState, "Phone", "Landowner Contact Phone Number");
                this.validateReqNumber(validationState, "EnableNotifications", "Enable Landowner Notifications?");
            }
        }
        dispose() {
            this.walk((entity) => { super.dispose(); }, { leading: true });
        }
        walk(func, args = {}) {
            let { leading, skipRoot } = args;
            if (!skipRoot && leading) {
                func(this);
            }
            if (!skipRoot && !leading) {
                func(this);
            }
        }
        toJson() {
            return {
                ObjectId: this.ObjectId,
                Id: this.Id,
                WaId: this.WaId,
                Type: this.Type,
                BusinessName: this.BusinessName,
                BusinessNameSearchIndex: this.BusinessNameSearchIndex,
                ContactFirstName: this.ContactFirstName,
                ContactLastName: this.ContactLastName,
                ContactFullName: this.ContactFullName,
                ContactNameSearchIndex: this.ContactNameSearchIndex,
                ContactPosition: this.ContactPosition,
                Signatory_1: this.Signatory_1,
                Signatory_2: this.Signatory_2,
                Signatory_3: this.Signatory_3,
                PostalAddress_1: this.PostalAddress_1,
                PostalAddress_2: this.PostalAddress_2,
                Town: this.Town,
                State: this.State,
                Postcode: this.Postcode,
                Phone: this.Phone,
                Fax: this.Fax,
                Email: this.Email,
                Abn: this.Abn,
                EnableNotifications: this.EnableNotifications,
                PersistanceState: this.PersistanceState,
                SecurityAccessLevel: this.SecurityAccessLevel
            };
        }
        static create(wa) {
            return new Promise((resolve, reject) => {
                let lo = new WaLandowner(null, wa);
                lo.Type = domain_1.WaLandownerTypeDomain.PersonOrPrivateIndividual;
                lo.EnableNotifications = 0;
                lo.State = "QLD";
                wa.WaLandowner.push(lo);
                if (wa.SelectedWaLandowner && wa.UseSameAddressForLandOwners) {
                    wa.syncLandOwnerAddresses();
                }
                resolve(lo);
            });
        }
        onNameChange() {
            this.ContactFullName = `${this.ContactFirstName ? this.ContactFirstName.trim() : ""} ${this.ContactLastName ? this.ContactLastName.trim() : ""}`;
        }
        onAddressChange() {
            this.Wa && this.Wa.syncLandOwnerAddresses();
        }
        updateApplicableFields() {
            if (this.Type != domain_1.WaLandownerTypeDomain.PersonOrPrivateIndividual) {
                this.IsBusinessNameRequired = true;
                this.IsContactPositionRequired = true;
            }
            else {
                this.IsBusinessNameRequired = false;
                this.IsContactPositionRequired = false;
            }
            if (this.Type == domain_1.WaLandownerTypeDomain.OtherCompanyAgreementToBeSignedByTwoDirectors || this.Type == domain_1.WaLandownerTypeDomain.OtherCompanyAgreementToBeSignedByADirectorAndTheSecretary) {
                this.IsSignatory1Required = true;
                this.IsSignatory2Required = true;
                this.IsSignatory3Required = false;
            }
            else if (this.Type == domain_1.WaLandownerTypeDomain.Trustee) {
                this.IsSignatory1Required = true;
                this.IsSignatory2Required = false;
                this.IsSignatory3Required = false;
            }
            else if (this.Type == domain_1.WaLandownerTypeDomain.PartnershipWithThreePartnersOrLess) {
                this.IsSignatory1Required = true;
                this.IsSignatory2Required = true;
                this.IsSignatory3Required = true;
            }
            else if (this.Type == domain_1.WaLandownerTypeDomain.PartnershipWithMoreThanThreePartners) {
                this.IsSignatory1Required = true;
                this.IsSignatory2Required = false;
                this.IsSignatory3Required = false;
            }
            else {
                this.IsSignatory1Required = false;
                this.IsSignatory2Required = false;
                this.IsSignatory3Required = false;
            }
            if (!this.IsBusinessNameRequired && this.BusinessName) {
                this.BusinessName = "";
            }
            if (!this.IsContactPositionRequired && this.ContactPosition) {
                this.ContactPosition = "";
            }
            if (!this.IsSignatory1Required && this.Signatory_1) {
                this.Signatory_1 = "";
            }
            if (!this.IsSignatory2Required && this.Signatory_2) {
                this.Signatory_2 = "";
            }
            if (!this.IsSignatory3Required && this.Signatory_3) {
                this.Signatory_3 = "";
            }
        }
    }
    exports.WaLandowner = WaLandowner;
    Object.defineProperty(WaLandowner, "Name", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "WaLandowner"
    });
    Object.defineProperty(WaLandowner, "AliasName", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Water Agreement Landowner"
    });
    Object.defineProperty(WaLandowner, "ObservableFields", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: ["ObjectId", "Id", "WaId", "Type", "BusinessName", "BusinessNameSearchIndex", "ContactFirstName", "ContactLastName", "ContactFullName", "ContactNameSearchIndex", "ContactPosition", "Signatory_1", "Signatory_2", "Signatory_3", "PostalAddress_1", "PostalAddress_2", "Town", "State", "Postcode", "Phone", "Fax", "Email", "Abn", "EnableNotifications"]
    });
    Object.defineProperty(WaLandowner, "WaIdReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(WaLandowner, "TypeDomain", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(WaLandowner, "TypeReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(WaLandowner, "BusinessNameLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 100
    });
    Object.defineProperty(WaLandowner, "BusinessNameReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(WaLandowner, "BusinessNameSearchIndexLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 255
    });
    Object.defineProperty(WaLandowner, "BusinessNameSearchIndexReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(WaLandowner, "ContactFirstNameLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 32
    });
    Object.defineProperty(WaLandowner, "ContactFirstNameReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(WaLandowner, "ContactLastNameLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 30
    });
    Object.defineProperty(WaLandowner, "ContactLastNameReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(WaLandowner, "ContactFullNameLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 63
    });
    Object.defineProperty(WaLandowner, "ContactFullNameReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(WaLandowner, "ContactNameSearchIndexLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 255
    });
    Object.defineProperty(WaLandowner, "ContactNameSearchIndexReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(WaLandowner, "ContactPositionLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 100
    });
    Object.defineProperty(WaLandowner, "ContactPositionReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(WaLandowner, "Signatory_1Length", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 255
    });
    Object.defineProperty(WaLandowner, "Signatory_1Req", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(WaLandowner, "Signatory_2Length", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 255
    });
    Object.defineProperty(WaLandowner, "Signatory_2Req", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(WaLandowner, "Signatory_3Length", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 255
    });
    Object.defineProperty(WaLandowner, "Signatory_3Req", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(WaLandowner, "PostalAddress_1Length", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 255
    });
    Object.defineProperty(WaLandowner, "PostalAddress_1Req", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(WaLandowner, "PostalAddress_2Length", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 255
    });
    Object.defineProperty(WaLandowner, "PostalAddress_2Req", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(WaLandowner, "TownLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 40
    });
    Object.defineProperty(WaLandowner, "TownReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(WaLandowner, "StateLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 3
    });
    Object.defineProperty(WaLandowner, "StateReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(WaLandowner, "PostcodeLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 4
    });
    Object.defineProperty(WaLandowner, "PostcodeReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(WaLandowner, "PhoneLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 14
    });
    Object.defineProperty(WaLandowner, "PhoneReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(WaLandowner, "FaxLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 14
    });
    Object.defineProperty(WaLandowner, "FaxReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(WaLandowner, "EmailLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 100
    });
    Object.defineProperty(WaLandowner, "EmailReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(WaLandowner, "AbnLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 12
    });
    Object.defineProperty(WaLandowner, "AbnReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(WaLandowner, "EnableNotificationsReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    tslib_1.__decorate([
        mobx_1.observable
    ], WaLandowner.prototype, "WaId", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaLandowner.prototype, "WaIdError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaLandowner.prototype, "Type", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaLandowner.prototype, "TypeError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaLandowner.prototype, "BusinessName", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaLandowner.prototype, "BusinessNameError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaLandowner.prototype, "BusinessNameSearchIndex", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaLandowner.prototype, "BusinessNameSearchIndexError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaLandowner.prototype, "ContactFirstName", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaLandowner.prototype, "ContactFirstNameError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaLandowner.prototype, "ContactLastName", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaLandowner.prototype, "ContactLastNameError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaLandowner.prototype, "ContactFullName", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaLandowner.prototype, "ContactFullNameError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaLandowner.prototype, "ContactNameSearchIndex", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaLandowner.prototype, "ContactNameSearchIndexError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaLandowner.prototype, "ContactPosition", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaLandowner.prototype, "ContactPositionError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaLandowner.prototype, "Signatory_1", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaLandowner.prototype, "Signatory_1Error", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaLandowner.prototype, "Signatory_2", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaLandowner.prototype, "Signatory_2Error", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaLandowner.prototype, "Signatory_3", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaLandowner.prototype, "Signatory_3Error", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaLandowner.prototype, "PostalAddress_1", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaLandowner.prototype, "PostalAddress_1Error", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaLandowner.prototype, "PostalAddress_2", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaLandowner.prototype, "PostalAddress_2Error", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaLandowner.prototype, "Town", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaLandowner.prototype, "TownError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaLandowner.prototype, "State", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaLandowner.prototype, "StateError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaLandowner.prototype, "Postcode", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaLandowner.prototype, "PostcodeError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaLandowner.prototype, "Phone", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaLandowner.prototype, "PhoneError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaLandowner.prototype, "Fax", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaLandowner.prototype, "FaxError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaLandowner.prototype, "Email", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaLandowner.prototype, "EmailError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaLandowner.prototype, "Abn", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaLandowner.prototype, "AbnError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaLandowner.prototype, "EnableNotifications", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaLandowner.prototype, "EnableNotificationsError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaLandowner.prototype, "Wa", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], WaLandowner.prototype, "onCreate", null);
    tslib_1.__decorate([
        mobx_1.action
    ], WaLandowner.prototype, "onRead", null);
    tslib_1.__decorate([
        mobx_1.action
    ], WaLandowner.prototype, "merge", null);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaLandowner.prototype, "IsBusinessNameRequired", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaLandowner.prototype, "IsContactPositionRequired", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaLandowner.prototype, "IsSignatory1Required", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaLandowner.prototype, "IsSignatory2Required", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaLandowner.prototype, "IsSignatory3Required", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], WaLandowner.prototype, "onNameChange", null);
    tslib_1.__decorate([
        mobx_1.action
    ], WaLandowner.prototype, "onAddressChange", null);
    tslib_1.__decorate([
        mobx_1.action
    ], WaLandowner.prototype, "updateApplicableFields", null);
});
